import styled from 'styled-components';

export const InputLanguagesWrapper = styled.div`
  display: flex;
  posiiton: relative;
`;
